import { render, staticRenderFns } from "./EndControlH5.vue?vue&type=template&id=48234a29&scoped=true"
import script from "./EndControlH5.vue?vue&type=script&setup=true&lang=ts"
export * from "./EndControlH5.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EndControlH5.vue?vue&type=style&index=0&id=48234a29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48234a29",
  null
  
)

export default component.exports